<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Who are we?" subtitle="Who are we?"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing1 [data]="pricing"></app-pricing1> -->
        <!-- PRICING TABLE SECTION END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing2 [data]="pricing"></app-pricing2> -->
        <!-- PRICING TABLE SECTION END -->
        <div class="container pt-2 pb-5">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <div class="image-container text-center mt-5 mb-5">
                        <img src="assets/images/flat-lay-of-autumnal-maple-leaves-in-circle-isolat-2024-11-19-12-51-53-utc.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12" >
                    <div class="text-content mobcontent" style="position: relative;bottom: 142px;">
                        <div class="separator-line mt-5 mb-4 mobcontene"></div>
                        <!-- <h5>Who Are We </h5> -->
                        <p >
                            Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.
                        </p>


                    </div>
                </div>
            </div>
        </div>



    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>